import Routing from "routing";

import type { Credentials, LoginResult } from "../types";

type RequestOptions = { signal?: AbortSignal };

export class LoginFailure extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = "LoginFailure";
  }
}

export interface LoginApi {
  login(
    credentials: Credentials,
    options?: RequestOptions,
  ): Promise<LoginResult>;
}

async function failureMessage(response: Response): Promise<string> {
  const payload = await response.json().catch(() => null);

  const detail =
    payload && typeof payload === "object" && "message" in payload
      ? String((payload as { message: unknown }).message)
      : null;

  return detail || response.statusText || `HTTP ${response.status}`;
}

export const loginApi: LoginApi = {
  async login(credentials, options) {
    const response = await fetch(Routing.generate("api_login"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
      ...options,
    });

    if (!response.ok) {
      throw new LoginFailure(await failureMessage(response), response.status);
    }

    return response.json();
  },
};
